var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NeoPdfManager } from "../../common/neopdf/NeoPdfManager";
import { generateNProjFromPdf } from "../../common/nproj/generateNprojFromPdf";
import { generatePodV2Sub } from "./generatePodV2Sub";
let shouldCancel = false;
export const userCancelMsg = "인쇄 취소";
export function generatePodV2(args) {
    return __awaiter(this, void 0, void 0, function* () {
        let { ncodePadding } = args;
        const { pdf_url, pdf_filename, startSobp, onProgress, requestNcodeGzipFunc, nprojXml } = args;
        if (!ncodePadding)
            ncodePadding = { x_nu: 0, y_nu: 0 };
        // PDF 파일을 읽고,
        const pdf = yield NeoPdfManager.getInstance().getDocument({
            url: pdf_url,
            filename: pdf_filename,
            purpose: "to generate ncoded pdf",
        });
        const generatedNprojXml = nprojXml || generateNProjFromPdf(pdf, startSobp, ncodePadding);
        const ret = yield generatePodV2Sub({
            pdf,
            nproj_xml: generatedNprojXml,
            requestNcodeGzipFunc,
            onProgress
        });
        // 이용자 중단
        if (shouldCancel) {
            const canceledRet = {
                ok: false,
                errorMsg: userCancelMsg,
                blob: undefined,
            };
            args.onProgress && args.onProgress({ step: pdf.numPages, totalSteps: pdf.numPages, canceled: true });
            return canceledRet;
        }
        return ret;
    });
}
export function cancelGeneratePOD() {
    shouldCancel = true;
}
export function isPodCanceled() {
    return shouldCancel;
}
export function setPodCancel(cancel) {
    shouldCancel = cancel;
}
//# sourceMappingURL=generatePodV2.js.map